import React, { Component } from 'react';

const divStyle = {
	fontSize: '20px',
	width: '600px',
	borderBottom: '1px solid black'
};


class LeadListHeader extends Component {
	render() {
		const { section, index } = this.props;
		return (
			<div style={divStyle} onClick={() => this.props.hideSection(index)}>
				{section.title}
			</div>
		);
	}
}

export default LeadListHeader;


// WEBPACK FOOTER //
// ./src/components/leadtracker/LeadListHeader.js